module.exports = __webpack_public_path__ + "static/media/counsellors.b8a61149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/counsellors.svg
// module id = 463
// module chunks = 5